export { default as GiftCardBlock } from './GiftCardBlock';
